import Services from "./body";


const Dashboard = () => {
  return (
    <>

      <Services />
    </>
  );
};

export default Dashboard;
